import React from "react";

import { FaqItemType } from "modules/Settings/Data/types";
import { Box } from "shared/ui-kit";

const FaqItem = ({ item }: { item: FaqItemType }) => <Box>{item.description}</Box>;

export default FaqItem;
